import type { SetVisualMediaPlayerAction } from "domains/visualMediaPlayer/actionTypes";
import { VisualMediaPlayerTypes } from "domains/visualMediaPlayer/actionTypes";

export const setVisualMediaPlayer = (meta: SetVisualMediaPlayerAction["meta"]): SetVisualMediaPlayerAction => ({
  type: VisualMediaPlayerTypes.SET,
  meta,
});
